import { elementSettings } from '@yola/ws-sdk';
import customTools from 'src/js/modules/custom-tools';
import tools from './tools';
import settings from './settings';
import { SLUG } from './constants';

const getExtension = () => ({
  slug: SLUG,
  title: 'WS Column',
  description: 'Extension for editing columns',
  settings: {
    querySelector: 'ws-column',
    allowedBlockIds: 'custom',
  },
  ui: {
    control: [],
  },
  init() {
    elementSettings.operations.registerElementSettings(settings.getAllColumnsSettings());
    elementSettings.operations.registerElementSettings(settings.getThisColumnSettings());
    customTools.operations.registerTool(tools.columnResizeToolSettings);
  },
});

export default getExtension;
